import { PathBase } from "@constellation-academy/epic-ui";

export class FeatureTogglesPath extends PathBase {
	static readonly pathKey = "featureToggles";
	static readonly pathName = "feature-toggles";
}
